
# Classroom

Amplify is about to release a new product. An amalgamation of 1+ years of work with a team of 1 engineer manager, 1 product owner and roughly 5 individual contributor engineers.

**The first goal:**

> Reduce the time it takes for a teacher to get a lesson on their screens in the classroom.

**The long-term goal:**

> Teach what you want... to who you want... whenever you want. In or out of the classroom... with or without devices.

The app is thusly named "Classroom".

## Problem statement

Lesson plans take a while to build. When you're an elementary school teacher with multiple domains/subjects to worry about this stuff all adds up. Sometimes you need a on-rails experience when you're outside of your comfort zone and other times you want Mr. Battaglia's special sauce included in the mix.

## Monkeys flinging shit at the wall

- Google Slides is the best "PowerPoint" editor
- Bring your own handouts and lesson details you've already made over the years
- A mailbox for students to receive new work asynchronously across all their classes/teachers
- The slide viewer needs to be vectorized to scale infinitely on any device

---

# 2 years in NYC

It's been a hot minute since that first fateful moving trip to NYC with all my shit in plastic lidded boxes I bought from Walmart the day before. Ratchet straps and some fancy tetris and suddenly I'm on my way to NYC to get to "work" on a Tuesday to negotiate my contract. Was at my client, Amplify, the following Monday and deep into a project within the next couple weeks as the lead consultant on a team of 2.

For my first "real job" out of college 
